window.Page = {

    pageTitle : document.querySelector('.page-title'),

    playerButton   : document.querySelector('.player-button'),
    playerTimeline : document.querySelector('.player-timeline'),
    playerProgress : document.querySelector('.player-progression'),
    playerFile     : document.querySelector('#recording'),
    playerInterval : null,

    index  : document.querySelector('.index'),
    header : document.querySelector('.header'),

    // Let's launch this thing
    liftoff : () => {
        Page.playPauseTheInterview()
        Page.skipToPoint()
        Page.setStickyIndexValue()
    },

    playPauseTheInterview : () => {

        if (!Page.playerFile) return;

        Page.playerButton.addEventListener('click' , () => {
            if (Page.playerFile.paused) {

                Page.playerButton.innerHTML = "Pause"
                Page.playerFile.play()
                Page.playerInterval = setInterval(function(){
                    Page.updateProgressBar()
                } , 100)




            } else {
                Page.playerButton.innerHTML = "Play"
                Page.playerFile.pause()
                clearInterval(Page.playerInterval)
            }
            
        })


    },

    skipToPoint : () => {

        if (!Page.playerFile) return;

        Page.playerTimeline.addEventListener('click' , (event) => {

            // Grab the position
            let position = 100 / Page.playerTimeline.clientWidth * event.layerX

            // Jump to that point
            Page.playerFile.currentTime = Page.playerFile.duration / 100 * position

            Page.updateProgressBar()

        })

    },

    updateProgressBar : () => {

        // get the current %
        let per = 100 / Page.playerFile.duration * Page.playerFile.currentTime

        // Update the style on the progression bar
        Page.playerProgress.style.width = `${per}%`

    },

    setStickyIndexValue : () => {

        // Do nothing if the width is not wide enough
        if (!window.matchMedia("(min-width: 1200px)").matches) return;

        function setTop () {

            // Grab index height
            let indexHeight  = Page.index.clientHeight - Page.pageTitle.clientHeight
            let windowHeight = window.innerHeight
            
            if (Math.abs(indexHeight) > Math.abs(windowHeight)) {
                Page.index.style.top = `-${indexHeight - windowHeight}px`
            }
        }

        window.addEventListener('load' , () => {setTop()})
        window.addEventListener('resize' , () => {setTop()})


    }

};

Page.liftoff()